module.exports = __webpack_public_path__ + "static/media/pet-friendly.a858ebdb.svg";